import React from 'react';

import s from './Heading.scss';

interface IProps {
  children: React.ReactNode;
  tag?: 'h1' | 'h2' | 'h3' | 'h4';
  isColumnLayout?: boolean;
}

export const Heading = ({ children, tag = 'h2', isColumnLayout }: IProps) => {
  if (!children) {
    return null;
  }

  const Tag = tag;

  return <Tag className={s('heading', { offset: isColumnLayout })}>{children}</Tag>;
};
